import { render, staticRenderFns } from "./PublishPro.vue?vue&type=template&id=546a2c31&scoped=true"
import script from "./PublishPro.vue?vue&type=script&lang=js"
export * from "./PublishPro.vue?vue&type=script&lang=js"
import style0 from "./PublishPro.vue?vue&type=style&index=0&id=546a2c31&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a2c31",
  null
  
)

export default component.exports